import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/auth';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuth = async () => {
      console.log('🔄 AuthCallback: Processing authentication...');
      // Call getCurrentUser to trigger auth storage
      const user = await authService.getCurrentUser();
      console.log('🔄 AuthCallback: User result:', user);
      
      // Small delay to ensure storage is complete
      setTimeout(() => {
        console.log('🔄 AuthCallback: Redirecting to admin...');
        navigate('/admin');
      }, 100);
    };
    
    handleAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-church-blue mx-auto mb-4"></div>
        <p>Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;